import { render, staticRenderFns } from "./coupon-ticket.vue?vue&type=template&id=029cbc88&"
import script from "./coupon-ticket.vue?vue&type=script&lang=js&"
export * from "./coupon-ticket.vue?vue&type=script&lang=js&"
import style0 from "./coupon-ticket.vue?vue&type=style&index=0&id=029cbc88&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports